import React from "react";
import {
  Grid,
  MenuItem,
  CircularProgress,
  Card,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { useFormikContext } from "formik";
import MDBox from "components/MDBox";
import FormField from "components/FormField";
import { useGetModalidadesTitulacionQuery } from "services/escuela/nomencladores/modalidad_titulacion.service";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";

const ExpedicionTab = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { values, errors, touched, handleChange, setFieldValue } =
    useFormikContext();

  const { data: modalidadesData, isLoading: isLoadingModalidades } =
    useGetModalidadesTitulacionQuery();
  const modalidades = modalidadesData?.results || modalidadesData || [];

  return (
    <MDBox mt={2}>
      <Card sx={{ overflow: "visible", paddingX: 2 }}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <FormField
              type="date"
              label="Fecha de Expedición"
              name="expedition_date"
              value={values.expedition_date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={errors.expedition_date && touched.expedition_date}
            />
          </Grid>

          <Grid item xs={12}>
            <FormField
              type="date"
              label="Fecha de Examen Profesional"
              name="fecha_examen_profesional"
              value={values.fecha_examen_profesional}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={
                errors.fecha_examen_profesional &&
                touched.fecha_examen_profesional
              }
            />
          </Grid>

          <Grid item xs={12}>
            <FormField
              select
              label="Modalidad de Titulación"
              name="modalidad_de_titulacion"
              value={values.modalidad_de_titulacion}
              onChange={handleChange}
              error={
                errors.modalidad_de_titulacion &&
                touched.modalidad_de_titulacion
              }
              disabled={isLoadingModalidades}
            >
              <MenuItem value="">
                <em>Seleccione una opción</em>
              </MenuItem>
              {isLoadingModalidades ? (
                <MenuItem disabled>
                  <CircularProgress size={20} />
                </MenuItem>
              ) : (
                modalidades.map((modalidad) => (
                  <MenuItem key={modalidad.id_modalidad} value={modalidad.url}>
                    {modalidad.nombre}
                  </MenuItem>
                ))
              )}
            </FormField>
          </Grid>
          <Grid item xs={12} display="flex" alignItems="center">
            <MDBox
              display="flex"
              alignItems="flex-start"
              flexDirection="column"
            >
              <MDTypography
                variant="button"
                fontWeight="regular"
                color={darkMode ? "white" : "text"}
              >
                Cumplió Servicio Social
              </MDTypography>
              <FormControlLabel
                control={
                  <Switch
                    checked={values.cumplio_servicio_social}
                    onChange={(e) =>
                      setFieldValue("cumplio_servicio_social", e.target.checked)
                    }
                    name="cumplio_servicio_social"
                    color="info"
                  />
                }
                label={values.cumplio_servicio_social ? "Si" : "No"}
                sx={{ ml: 0, mt: 1 }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </Card>
    </MDBox>
  );
};

export default ExpedicionTab;
